<template>
  <section class="text-white">
    <b-container class="">
      <b-row>
        <b-col sm="12" md="12" lg="12" >
          <iframe width="100%" height="470" src="https://www.youtube.com/embed/q8rdAjMjn6Q" title="Nuestras campañas suman 5 premios internacionales Reed Latino y más de 25 nominaciones." frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="">
      <b-row class="">
        <b-col sm="12" md="12" lg="12" style="margin-top: 120px;">
          <h1 class="text-left font-weight-bold">
            <span>SERVICIOS</span>
          </h1>
        </b-col>
        <b-col md="6" style="margin-top: 10px;">
          <img class="" style="max-height: 800px" src="../assets/img/adolfo_services.png"/>
        </b-col>
        <b-col md="6" style="margin-top: 100px; border-left: 2px solid red">
          <div>
            <ul style="font-size: 1.2em; margin-top: 40px">
              <li>Diseño de la estrategia</li>
              <li>Estrategia digital electoral</li>
              <li>Estrategia digital de Gobierno</li>
              <li>Construcción del mensaje</li>
              <li>Discurso del candidato</li>
              <li>Imagen del candidato</li>
              <li>Media training</li>
              <li>Redacción</li>
              <li>Arte gráfico de la campaña</li>
              <li>Foto de campaña</li>
              <li>Logo, slogan, jingle</li>
              <li>Avisos de prensa</li>
              <li>Producción audiovisual</li>
              <li>Spots televisión y redes</li>
              <li>Spots de radio</li>
              <li>Planificación de medios</li>
              <li>Programa de Gobierno</li>
              <li>Dirección del War Room</li>
              <li>Capacitación de los equipos</li>
              <li>Marketing de Gobierno</li>
              <li>Manejo de crisis</li>
              <li>Asesoría en línea</li>
            </ul>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "Courses"
}
</script>

<style scoped>

</style>
